import { useEffect, useState } from 'react';

const readSessionValue = (key, fallbackValue) => {
  if (typeof window === 'undefined') {
    return fallbackValue;
  }

  try {
    const storedValue = window.sessionStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : fallbackValue;
  } catch (error) {
    return fallbackValue;
  }
};

const useSessionState = (key, fallbackValue) => {
  const [value, setValue] = useState(() => readSessionValue(key, fallbackValue));

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // Ignore storage quota/private mode issues; UI state persistence is best effort.
    }
  }, [key, value]);

  return [value, setValue];
};

export default useSessionState;
